import React from "react";
import { partyTheme } from "../pages/accountDetail/accountDetailTheme";

const metaTextStyle = {
  fontSize: "12px",
  lineHeight: 1.35,
  marginBottom: "8px",
  color: "#3d3d3a",
};

const logoutButtonStyle = {
  padding: "4px 8px",
  marginLeft: "8px",
  cursor: "pointer",
  border: "1px solid #d0d0d0",
  borderRadius: 0,
  background: "#fff",
  fontSize: "11px",
  lineHeight: 1.25,
};

const titleStyle = {
  margin: 0,
  fontSize: "18px",
  lineHeight: 1.25,
  fontWeight: 600,
  color: partyTheme.chrome.heading,
};

/**
 * Shared page header (matches Accounts layout): optional leading row, brand / session line, title, optional subtitle.
 */
function AppPageHeader({
  title,
  subtitle,
  user,
  onLogout,
  /** Shown when there is no logged-in row (e.g. public pages). String or React node. */
  metaLine,
  children,
}) {
  return (
    <header
      style={{
        background: "#fff",
        borderBottom: `1px solid ${partyTheme.chrome.sidebarRule}`,
        padding: "12px 16px",
      }}
    >
      {children}
      {user && onLogout ? (
        <div style={metaTextStyle}>
          dehisce.com | Logged in as: <strong>{user?.display_name}</strong> (
          {user?.email})
          <button type="button" onClick={onLogout} style={logoutButtonStyle}>
            Logout
          </button>
        </div>
      ) : metaLine ? (
        <div style={metaTextStyle}>{metaLine}</div>
      ) : null}
      <h1 style={titleStyle}>{title}</h1>
      {subtitle ? (
        <div
          style={{
            fontSize: "11px",
            lineHeight: 1.35,
            color: "#5c5a54",
            marginTop: "4px",
          }}
        >
          {subtitle}
        </div>
      ) : null}
    </header>
  );
}

export default AppPageHeader;
